import { Link } from 'react-router-dom';
import { GuestGuard } from '@/guards';
import { BackgroundPattern } from '@/components/auth/BackgroundPattern';
import { WaitlistForm } from '@/components/waitlist/WaitlistForm';
import { CountdownTimer } from '@/components/waitlist/CountdownTimer';

export default function RegisterPage() {
  return (
    <GuestGuard>
      <div className="min-h-screen flex items-center justify-center theme-bg p-4 overflow-hidden">
        <BackgroundPattern />

        {/* Content */}
        <div className="relative w-full max-w-lg mx-auto z-10 flex flex-col items-center">

          <div className="w-full theme-card rounded-2xl border p-6 md:p-10 animate-fade-in backdrop-blur-xl bg-[color:var(--card-bg)]/85 text-center">
            <Link to="/" className="inline-block mb-6">
              <img src="/logo-mini.svg" alt="Logo" className="h-10 w-auto mx-auto" />
            </Link>

            <h1 className="text-3xl md:text-4xl font-bold text-white mb-3 tracking-tight">
              Acesso Antecipado
            </h1>

            <p className="text-base text-zinc-400 max-w-sm mx-auto mb-8">
              <span className="text-indigo-400 font-semibold">Cadastre-se na waitlist</span> e ganhe{' '}
              <span className="text-white font-bold bg-indigo-500/20 px-1.5 py-0.5 rounded border border-indigo-500/30">
                50 créditos
              </span>{' '}
              no starter bundle.
            </p>

            <div className="mb-8 scale-90 origin-center">
              <CountdownTimer />
            </div>

            <WaitlistForm />

            <div className="mt-6 pt-6 border-t theme-border">
              <p className="text-sm theme-text-muted">
                Já tem uma conta?{' '}
                <Link to="/login" className="text-indigo-400 hover:text-indigo-300 font-medium transition-colors">
                  Fazer login
                </Link>
              </p>
            </div>
          </div>

        </div>
      </div>
    </GuestGuard>
  );
}
